module.exports = __webpack_public_path__ + "img/restaurant.5be6dc5c.png";